import request from '@/api/request'
import type { SpringPage } from '@/api/types/domain'

/** `GET …/repay/parents` */
export interface RepayParentRow {
  id: number
  orderNum?: string | null
  user?: string | null
  customerName?: string | null
  money?: number | null
  months?: number | null
  addtime?: number | null
  status?: number | null
  statusText?: string | null
  pendingAwaitingRepay?: boolean | null
}

/** voucher 分期行 */
export interface VoucherRow {
  id?: number | null
  user?: string | null
  ordernum?: string | null
  money?: number | null
  months?: number | null
  ofnumber?: number | null
  currentInstallment?: number | null
  monthmoney?: number | null
  zfimg?: string | null
  status?: number | null
  addtime?: string | null
  huantime?: string | null
  paytime?: string | null
}

export function fetchRepayParents(
  pending: boolean,
  keyword: string | undefined,
  page: number,
  rows: number,
) {
  return request.get<SpringPage<RepayParentRow>>('/api/admin/backoffice/daikuan/repay/parents', {
    params: {
      pending,
      ...(keyword?.trim() ? { keyword: keyword.trim() } : {}),
      page,
      rows,
    },
  })
}

/** 分期详情；与主列表一致使用从 1 开始的 page */
export function fetchRepayDetails(ordernum: string, pageUi = 1, rows = 200) {
  return request.get<SpringPage<VoucherRow>>('/api/admin/backoffice/daikuan/repay/details', {
    params: {
      ordernum: ordernum.trim(),
      page: Math.max(1, pageUi),
      rows,
    },
  })
}
